import { render, staticRenderFns } from "./PersonOverviewDialog.vue?vue&type=template&id=2c8fe3b3&scoped=true"
import script from "./PersonOverviewDialog.vue?vue&type=script&lang=js"
export * from "./PersonOverviewDialog.vue?vue&type=script&lang=js"
import style0 from "./PersonOverviewDialog.vue?vue&type=style&index=0&id=2c8fe3b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8fe3b3",
  null
  
)

export default component.exports